import { linspace } from "../utils/number";

export const locationKeyList = ["YSCC", "SPE", "SPW", "SAYADO"];

export const AlarmType = {
    health: "health",
    radio: "radio",
};

export const deviceMoniteringDeviceList = [
    "Spectrum_Analyzer_1",
    "Spectrum_Analyzer_2",
    "Gps_Sensor_1",
    "Gps_Sensor_2",
    "Temperature_Sensor",
    "Direct_Current_Power_1",
    "Direct_Current_Power_2",
    "Direct_Current_Power_3",
    "Direct_Current_Power_4",
    "Direct_Current_Power_5",
    "Noise_Source",
    "Outdoor_Cabinet",
    "Energy_Gazer",
    "Lan_Switch_1",
    "Lan_Switch_2",
    "Lan_Switch_3",
    "Lan_Switch_4",
    "Measurement_Pc_Main",
    "Measurement_Pc_Sub",
    "health_setting",
];

export const DeviceKeys = {
    SPEANA_1: "Spectrum_Analyzer_1",
    SPEANA_2: "Spectrum_Analyzer_2",
    GPS_1: "Gps_Sensor_1",
    GPS_2: "Gps_Sensor_2",
    TEMP_SENSOR: "Temperature_Sensor",
    DC_POWER_1: "Direct_Current_Power_1",
    DC_POWER_2: "Direct_Current_Power_2",
    DC_POWER_3: "Direct_Current_Power_3",
    DC_POWER_4: "Direct_Current_Power_4",
    DC_POWER_5: "Direct_Current_Power_5",
    NOISE_SOURCE: "Noise_Source",
    OUTDOOR_CABINET: "Outdoor_Cabinet",
    ENERGY_GAZER: "Energy_Gazer",
    LAN_SWITCH_1: "Lan_Switch_1",
    LAN_SWITCH_2: "Lan_Switch_2",
    LAN_SWITCH_3: "Lan_Switch_3",
    LAN_SWITCH_4: "Lan_Switch_4",
    MEASUREMENT_PC_MAIN: "Measurement_Pc_Main",
    MEASUREMENT_PC_SUB: "Measurement_Pc_Sub",
    HEALTH_SETTING: "health_setting",
    ALL: "All",
};

export const DeviceKeitouzuNames = {
    [DeviceKeys.SPEANA_1]: "スペアナ #1",
    [DeviceKeys.SPEANA_2]: "スペアナ #2",
    [DeviceKeys.GPS_1]: "GPS #1",
    [DeviceKeys.GPS_2]: "GPS #2",
    [DeviceKeys.TEMP_SENSOR]: "温度センサー",
    [DeviceKeys.DC_POWER_1]: "DC電源 #1",
    [DeviceKeys.DC_POWER_2]: "DC電源 #2",
    [DeviceKeys.DC_POWER_3]: "DC電源 #3",
    [DeviceKeys.DC_POWER_4]: "DC電源 #4",
    [DeviceKeys.DC_POWER_5]: "DC電源 #5",
    [DeviceKeys.NOISE_SOURCE]: "ノイズソース温度",
    [DeviceKeys.OUTDOOR_CABINET]: "ラック内温度",
    [DeviceKeys.ENERGY_GAZER]: "電流モニター",
    [DeviceKeys.LAN_SWITCH_1]: "ネットワーク\nSW #1",
    [DeviceKeys.LAN_SWITCH_2]: "ネットワーク\nSW #2",
    [DeviceKeys.LAN_SWITCH_3]: "ネットワーク\nSW #3",
    [DeviceKeys.LAN_SWITCH_4]: "ネットワーク\nSW #4",
    [DeviceKeys.MEASUREMENT_PC_MAIN]: "計測PC\n本番機",
    [DeviceKeys.MEASUREMENT_PC_SUB]: "計測PC\n予備機",
};

export const DeviceLogNames = {
    [DeviceKeys.SPEANA_1]: "スペアナ #1",
    [DeviceKeys.SPEANA_2]: "スペアナ #2",
    [DeviceKeys.GPS_1]: "GPS #1",
    [DeviceKeys.GPS_2]: "GPS #2",
    [DeviceKeys.TEMP_SENSOR]: "温度センサー",
    [DeviceKeys.DC_POWER_1]: "DC電源 #1",
    [DeviceKeys.DC_POWER_2]: "DC電源 #2",
    [DeviceKeys.DC_POWER_3]: "DC電源 #3",
    [DeviceKeys.DC_POWER_4]: "DC電源 #4",
    [DeviceKeys.DC_POWER_5]: "DC電源 #5",
    [DeviceKeys.NOISE_SOURCE]: "ノイズソース温度",
    [DeviceKeys.OUTDOOR_CABINET]: "ラック内温度",
    [DeviceKeys.ENERGY_GAZER]: "電流モニター",
    [DeviceKeys.LAN_SWITCH_1]: "NWSW #1",
    [DeviceKeys.LAN_SWITCH_2]: "NWSW #2",
    [DeviceKeys.LAN_SWITCH_3]: "NWSW #3",
    [DeviceKeys.LAN_SWITCH_4]: "NWSW #4",
    [DeviceKeys.MEASUREMENT_PC_MAIN]: "計測PC 本番",
    [DeviceKeys.MEASUREMENT_PC_SUB]: "計測PC 予備",
    [DeviceKeys.HEALTH_SETTING]: "機器監視設定",
};

export const logTypeNames = {
    "Threshold A": "A:時間率判定",
    "Threshold B": "B-1:最大値判定",
    "Threshold E": "B-2:サービス影響判定",
    "Threshold C": "C:合計値判定",
    "Threshold D": "D:合計値判定",
    "signal": "校正経路監視",
    "Alive": "死活監視",
    "Reboot": "プロセス再起動",
    "Ping": "PING",
    "SCPI": "内部校正",
    "Max_Electricity": "電流上限",
    "Min_Electricity": "電流下限",
    "Max_Temperature": "温度上限",
    "Min_Temperature": "温度下限",
    "Disconnect_Sensor": "センサー異常",
    "LinkDown": "LinkDown",
    "LinkUp": "LinkUp",
    "ColdStart": "ColdStart",
    "WarmStart": "WarmStart",
    "Unable_Monitoring": "監視不能",
    "Change": "設定変更",
    "snmp": "SNMPTrap",
    "Consumption_Current": "消費電力監視",
    "Temperature": "温度監視",
    "Process": "プロセス監視",
    "ApiProcess": "APIプロセス",
    "WebProcess": "WEBサーバプロセス",
    "MainProcess": "メインプロセス",
    "MeasurementProcess": "計測プロセス",
    "HealthProcess": "機器監視プロセス",
    "UploadProcess": "アップロードプロセス",
    "S3": "S3アップロード監視",
    "s3_upload_confirmation_alarm_block": "S3アップロード監視 (block)",
    "s3_upload_confirmation_alarm_plot": "S3アップロード監視 (plot)",
    "s3_upload_confirmation_alarm_calibration": "S3アップロード監視 (calibration)",
    "s3_upload_confirmation_alarm_trace": "S3アップロード監視 (trace)",
}

// ログ種別の名前を取得
export const getLogTypeName = (log) => {
    // Valueの場合
    return logTypeNames[log.log_type] || "";
}

export const waveMoniteringBandList = [
    "3400-3440",
    "3440-3480",
    "3480-3520",
    "3520-3560",
    "3560-3600",
    "3600-3700",
    "3700-3800",
    "3800-3900",
    "3900-4000",
    "4000-4100",
    "total",
    "S1-A1",
    "S1-A2",
    "S1-A3",
    "S2-A1",
    "S2-A2",
    "S2-A3"
];

export const waveMoniteringBandNameList = {
    "3400-3440": "S-1",
    "3440-3480": "D-1",
    "3480-3520": "D-2",
    "3520-3560": "K-1",
    "3560-3600": "S-2",
    "3600-3700": "D-3",
    "3700-3800": "K-2",
    "3800-3900": "R-1",
    "3900-4000": "S-3",
    "4000-4100": "K-3",
    "total": "合計",
    "S1-A1": "スペアナ1-1",
    "S1-A2": "スペアナ1-2",
    "S1-A3": "スペアナ1-3",
    "S2-A1": "スペアナ2-1",
    "S2-A2": "スペアナ2-2",
    "S2-A3": "スペアナ2-3",
    "radio_setting": "電波干渉監視設定",
    "display_setting": "表示ラベル設定",
    "mask_setting": "干渉波マスク設定",
}

export const waveMoniteringBandThresholdList = {
    "3400-3440": ["Threshold A", "Threshold B", "Threshold E", "Threshold C"],
    "3440-3480": ["Threshold A", "Threshold B", "Threshold E", "Threshold C"],
    "3480-3520": ["Threshold A", "Threshold B", "Threshold E", "Threshold C"],
    "3520-3560": ["Threshold A", "Threshold B", "Threshold E", "Threshold C"],
    "3560-3600": ["Threshold A", "Threshold B", "Threshold E", "Threshold C"],
    "3600-3700": ["Threshold A", "Threshold B", "Threshold E", "Threshold C"],
    "3700-3800": ["Threshold A", "Threshold B", "Threshold E", "Threshold C"],
    "3800-3900": ["Threshold A", "Threshold B", "Threshold E", "Threshold C"],
    "3900-4000": ["Threshold A", "Threshold B", "Threshold E", "Threshold C"],
    "4000-4100": ["Threshold A", "Threshold B", "Threshold E", "Threshold C"],
    "total": ["Threshold D"],
    "S1-A1": ["signal"],
    "S1-A2": ["signal"],
    "S1-A3": ["signal"],
    "S2-A1": ["signal"],
    "S2-A2": ["signal"],
    "S2-A3": ["signal"],
}

// タブ名
export const TAB_ALL = "全拠点";
export const TAB_YSCC = "YSCC";
export const TAB_SPE = "SPE";
export const TAB_SPW = "SPW";
export const TAB_SAYADO = "SAYADO";


export const LogRelation = {
    [AlarmType.health]: {
        [DeviceKeys.SPEANA_1]: ["Ping", "SCPI", "Unable_Monitoring"],
        [DeviceKeys.SPEANA_2]: ["Ping", "SCPI", "Unable_Monitoring"],
        [DeviceKeys.GPS_1]: ["Alive", "Unable_Monitoring"],
        [DeviceKeys.GPS_2]: ["Alive", "Unable_Monitoring"],
        [DeviceKeys.TEMP_SENSOR]: ["Ping"],
        [DeviceKeys.DC_POWER_1]: ["Ping", "Max_Electricity", "Min_Electricity", "Unable_Monitoring", "Consumption_Current"],
        [DeviceKeys.DC_POWER_2]: ["Ping", "Max_Electricity", "Min_Electricity", "Unable_Monitoring", "Consumption_Current"],
        [DeviceKeys.DC_POWER_3]: ["Ping", "Max_Electricity", "Min_Electricity", "Unable_Monitoring", "Consumption_Current"],
        [DeviceKeys.DC_POWER_4]: ["Ping", "Max_Electricity", "Min_Electricity", "Unable_Monitoring", "Consumption_Current"],
        [DeviceKeys.DC_POWER_5]: ["Ping", "Max_Electricity", "Min_Electricity", "Unable_Monitoring", "Consumption_Current"],
        [DeviceKeys.NOISE_SOURCE]: ["Max_Temperature", "Min_Temperature", "Disconnect_Sensor", "Unable_Monitoring", "Temperature"],
        [DeviceKeys.OUTDOOR_CABINET]: ["Max_Temperature", "Min_Temperature", "Disconnect_Sensor", "Unable_Monitoring", "Temperature"],
        [DeviceKeys.ENERGY_GAZER]: ["Ping", "Max_Electricity", "Min_Electricity", "Unable_Monitoring", "Consumption_Current"],
        [DeviceKeys.LAN_SWITCH_1]: ["Ping", "snmp", "LinkDown", "LinkUp", "ColdStart", "WarmStart"],
        [DeviceKeys.LAN_SWITCH_2]: ["Ping", "snmp", "LinkDown", "LinkUp", "ColdStart", "WarmStart"],
        [DeviceKeys.LAN_SWITCH_3]: ["Ping", "snmp", "LinkDown", "LinkUp", "ColdStart", "WarmStart"],
        [DeviceKeys.LAN_SWITCH_4]: ["Ping", "snmp", "LinkDown", "LinkUp", "ColdStart", "WarmStart"],
        [DeviceKeys.MEASUREMENT_PC_MAIN]: [
            "Alive", "Reboot",
            "ApiProcess", "WebProcess", "MainProcess", "MeasurementProcess", "HealthProcess", "UploadProcess",
            "S3", "s3_upload_confirmation_alarm_block", "s3_upload_confirmation_alarm_plot", "s3_upload_confirmation_alarm_calibration", "s3_upload_confirmation_alarm_trace"
        ],
        [DeviceKeys.MEASUREMENT_PC_SUB]: ["Alive", "Reboot"],
        [DeviceKeys.HEALTH_SETTING]: ["Change"],
    },
    [AlarmType.radio]: {
        "3400-3440": ["Threshold A", "Threshold B", "Threshold E", "Threshold C"],
        "3440-3480": ["Threshold A", "Threshold B", "Threshold E", "Threshold C"],
        "3480-3520": ["Threshold A", "Threshold B", "Threshold E", "Threshold C"],
        "3520-3560": ["Threshold A", "Threshold B", "Threshold E", "Threshold C"],
        "3560-3600": ["Threshold A", "Threshold B", "Threshold E", "Threshold C"],
        "3600-3700": ["Threshold A", "Threshold B", "Threshold E", "Threshold C"],
        "3700-3800": ["Threshold A", "Threshold B", "Threshold E", "Threshold C"],
        "3800-3900": ["Threshold A", "Threshold B", "Threshold E", "Threshold C"],
        "3900-4000": ["Threshold A", "Threshold B", "Threshold E", "Threshold C"],
        "4000-4100": ["Threshold A", "Threshold B", "Threshold E", "Threshold C"],
        "total": ["Threshold D"],
        "radio_setting": ["Change"],
        "mask_setting": ["Change"],
        "display_setting": ["Change"],
        "S1-A1": ["signal"],
        "S1-A2": ["signal"],
        "S1-A3": ["signal"],
        "S2-A1": ["signal"],
        "S2-A2": ["signal"],
        "S2-A3": ["signal"],
    },
}

// 表示設定のデフォルト
export const DEFAULT_DISPLAY_SETTING = {
    "location_name": {
        "YSCC": "YSCC",
        "SPE": "SPE",
        "SPW": "SPW",
        "SAYADO": "小夜戸"
    },
    "band_label": {
        "3400-3440": {
            "name": "S-1",
            "color": "#bbbcbe"
        },
        "3440-3480": {
            "name": "D-1",
            "color": "#cc0033"
        },
        "3480-3520": {
            "name": "D-2",
            "color": "#cc0033"
        },
        "3520-3560": {
            "name": "K-1",
            "color": "#eb5505"
        },
        "3560-3600": {
            "name": "S-2",
            "color": "#bbbcbe"
        },
        "3600-3700": {
            "name": "D-3",
            "color": "#cc0033"
        },
        "3700-3800": {
            "name": "K-2",
            "color": "#eb5505"
        },
        "3800-3900": {
            "name": "R-1",
            "color": "#ff00ff"
        },
        "3900-4000": {
            "name": "S-3",
            "color": "#bbbcbe"
        },
        "4000-4100": {
            "name": "K-3",
            "color": "#eb5505"
        }
    }
}

// 計測時の周波数帯域
export const BAND_RANGE = {
    min: 3380,
    max: 4120,
}

// 実際に監視する帯域
export const WAVE_MONITERING_BAND_LIST = {
    min: 3400,
    max: 4100,
}

// 測定ポイント数
export const MEASUREMENT_POINT_COUNT = 2221;

// 測定ポイントリスト
export const MEASUREMENT_FREQUENCY_LIST = linspace(
    BAND_RANGE.min,
    BAND_RANGE.max,
    MEASUREMENT_POINT_COUNT
).map((v) => {
    return Number(v.toFixed(3))
}).filter((v) => {
    return v >= WAVE_MONITERING_BAND_LIST.min && v <= WAVE_MONITERING_BAND_LIST.max
});

// 計測ポイントの値になるように変換
export const getNearestValue = (val) => {
    // xTickListのなかで1番近い値を取得
    const nearest = MEASUREMENT_FREQUENCY_LIST.reduce((prev, curr) => {
        return Math.abs(curr - val) < Math.abs(prev - val) ? curr : prev;
    });

    return nearest;
}